import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";

import NotFound from "pages/NotFound";
import Home from "./pages/Home";
import Login from "./pages/Login";

// Customer pages
import CustomerDashboard from "./pages/customer-dashboard";
import CustomerMessagesV2EnquiryInbox from "pages/customer-messages-v2-enquiry-inbox";
import CustomerMessagesV2OffersList from "pages/customer-messages-v2-offers-list";
import CustomerMessagesV2Conversation from "./pages/messages-v2-conversation";
import CustomerAccountSettings from "./pages/customer-account-settings";
import CustomerNotificationCentre from "./pages/customer-notification-centre";
import CustomerRegistration from "./pages/customer-registration";
import CreateEnquiry from "./pages/create-enquiry";

// Agent pages
import AgentDashboard from "./pages/agent-dashboard";
import AgentMessagesV2Inbox from "./pages/agent-messages-v2-inbox";
import AgentMessagesV2ChatThread from "./pages/agent-messages-v2-chat-thread";
import AgentRegistration from "./pages/agent-registration";
import AgentVetting from "./pages/agent-vetting";
import AgentRejectionNotice from "./pages/agent-rejection-notice";
import AgentAccountSettings from "./pages/agent-account-settings";
import AgentNotificationCentre from "./pages/agent-notification-centre";

// Staff pages
import StaffDashboard from "./pages/staff-dashboard";

// Payment pages
import BookingCheckout from "./pages/booking-checkout";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          
          {/* Customer routes */}
          <Route path="/customer-dashboard" element={<CustomerDashboard />} />
          <Route path="/customer-registration" element={<CustomerRegistration />} />
          <Route path="/customer-account-settings" element={<CustomerAccountSettings />} />
          <Route path="/customer-notification-centre" element={<CustomerNotificationCentre />} />
          <Route path="/create-enquiry" element={<CreateEnquiry />} />
          
          {/* Customer messaging v2 routes */}
          <Route path="/customer/messages-v2" element={<CustomerMessagesV2EnquiryInbox />} />
          <Route path="/customer/messages-v2/enquiry/:enquiryId" element={<CustomerMessagesV2OffersList />} />
          <Route path="/customer/messages-v2/conversation/:conversationId" element={<CustomerMessagesV2Conversation />} />
          
          {/* Agent routes */}
          <Route path="/agent-dashboard" element={<AgentDashboard />} />
          <Route path="/agent-registration" element={<AgentRegistration />} />
          <Route path="/agent-vetting" element={<AgentVetting />} />
          <Route path="/agent-rejection-notice" element={<AgentRejectionNotice />} />
          <Route path="/agent-account-settings" element={<AgentAccountSettings />} />
          <Route path="/agent-notification-centre" element={<AgentNotificationCentre />} />
          
          {/* Agent messaging routes (v2 + alias) */}
          <Route path="/agent/messages-v2" element={<AgentMessagesV2Inbox />} />
          <Route path="/agent/messages" element={<AgentMessagesV2Inbox />} />
          <Route path="/agent/messages/:conversationId" element={<AgentMessagesV2ChatThread />} />
          <Route path="/agent/messages-v2/:conversationId" element={<AgentMessagesV2ChatThread />} />
          
          {/* Staff routes */}
          <Route path="/staff-dashboard" element={<StaffDashboard />} />
          
          {/* Payment routes */}
          <Route path="/booking-checkout/:conversationId" element={<BookingCheckout />} />
          
          {/* 404 fallback */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;